import { freddyTheme as theme, type SxProps } from '@coolblue-development/freddy';
import type { CSSProperties } from 'react';

const opacity = theme.opacity;
const { medium, fast } = theme.motionDuration;
const { easeInOut, easeOut } = theme.motionEasing;
const fastEaseInOut = `${fast} ${easeInOut}`;

const arbitrarilyLargeSizeValue = '10rem';

const container: SxProps = {
  width: '100%',
  transition: `columnGap ${medium} ${easeOut}`,

  'input[type="checkbox"]:not(:checked)': {
    '--cb-switch-color-background-container':
      'var(--cb-color-background-interactive-control-contrast-hovered)'
  }
};

const toggleSwitch: SxProps = {
  '@keyframes revealHorizontal': {
    to: { maxWidth: arbitrarilyLargeSizeValue }
  },
  animation: `revealHorizontal .4s ${easeOut} forwards`,
  maxWidth: 0,
  minWidth: 0,
  overflow: 'hidden'
};

const icon: SxProps = {
  '@keyframes revealOpacity': {
    to: { opacity: 1 }
  },
  '@keyframes drawCheckmark': {
    to: { strokeDashoffset: 0 }
  },
  svg: {
    animation: `revealOpacity 0.25s ${easeInOut} forwards`,
    gridArea: '1 / 1',
    opacity: opacity.transparent
  }
};

const checkmarkPath: CSSProperties = {
  animation: `drawCheckmark ${fastEaseInOut} forwards`,
  animationDelay: '.15s',
  strokeDasharray: 20,
  strokeDashoffset: 20
};

const getAccessorySummary = (toggled: boolean): SxProps => ({
  gridRow: 2,
  gridColumn: 2,
  maxHeight: toggled ? arbitrarilyLargeSizeValue : 0,
  transition: `
    max-height ${fastEaseInOut},
    opacity 0.25s ${easeInOut},
    transform ${fastEaseInOut}
  `,
  opacity: opacity[toggled ? 'full' : 'transparent'],

  button: {
    fontWeight: theme.typography.fontWeight.openSans.normal,
    minHeight: 0
  }
});

export default {
  container,
  toggleSwitch,
  icon,
  checkmarkPath,
  getAccessorySummary
};
